import type { AccessChecker } from './types';

import { useGroupInfos } from '~entities/group';

export function useAccessChecker(): AccessChecker {
  const { features } = useGroupInfos();

  return ({ isAdmin, requiredFeatures = [] }) =>
    isAdmin &&
    (requiredFeatures.length === 0 ||
      requiredFeatures.some((feature) => features.includes(feature)));
}
